export const loadingsSimulation = {
	tableLoading: false,
	buttonProviderLoading: false,
	buttonCreateAssestLoading: false,
	buttonEditSimulationLoading: false,
	buttonCreateEquivalency: false,
	loadingTables: false,
};

export const formInitEquivalency = {
	assetMoneyMX: 0,
	providerMoneyMX: 0,
	assetMoneyDLL: 0,
	providerMoneyDLL: 0,
};

export const modalsSimulation = {
	equivalency: false,
	assets: false,
	provider: false,
};

export const modalsTypeSimulation = {
	equivalency: "equivalency",
	assets: "assets",
	provider: "provider",
};

export const formInitAssetsSimulation = {
	name: "",
	price: 0,
	currency: "MXN",
	link: "",
	status: "",
	area: "",
};

export const jsonDataStatusSimulation = {
	In_review: { name: "En revisión", color: "#3D3D3D" },
	Approved: { name: "Aprobado", color: "#459A33" },
	Denied: { name: "Denegado", color: "#B64D34" },
	Simulation: { name: "Simulación", color: "#4385F5" },
};

export const formInitProviderSimulation = {
	name: "",
	price: 0,
	currency: "MXN",
	link: "",
	status: "",
	area: "",
	outsourceHours: 0,
	budget: 0,
	providerHours: 0,
};
